import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getManualResourceIdControl } from './shared-control-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';

const azureSearchResourceId = '/subscriptions/<subscriptionID>/resourceGroups/<resourceGroupName>/providers/Microsoft.Search/searchServices/<resourceName>';
const azureSearchResourceIdFormat = '\/?subscriptions\/.+\/resourceGroups\/.+\/providers\/Microsoft.Search\/searchServices\/.+';
const azureSearchResourceIdErrorMessage = format(stringResources.InvalidResourceId, azureSearchResourceId);

export const azureSearchPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Search/searchServices',
    connectionSuffix: 'accessControl',
    resourceIdValidator: azureSearchResourceIdFormat,
    groupIdMetadata: {
        searchService: {
            linkedServiceType: adfModelTypeMap.azureSearch.linkedServiceType,
            groupId: 'searchService',
            iconClass: 'svg-i-100x100-SearchIndex',
            displayName: stringResources.AzureSearch_DisplayText,
            controls: {
                creationControls: [{
                    type: 'radio-switch',
                    nested: 1,
                    label: stringResources.AccountSelectionMethodLabel,
                    description: stringResources.AzureSql_SelectMethodDescription,
                    options: azureResourceSelectMethodOptions,
                    isLabelVertical: true,
                    defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
                    cases: [
                        {
                            caseValue: 'azure',
                            children: [
                                {
                                    type: 'azure-search-select',
                                    bind: {
                                        resourceID: 'privateLinkResourceId'
                                    },
                                    fetchAccountKey: false,
                                    validators: {
                                        resourceID: [
                                            { type: 'required', errorMessage: '' }
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            caseValue: 'manual',
                            children: [
                                getManualResourceIdControl(
                                    format(stringResources.PrivateEndpointResourceIdPlaceholder, azureSearchResourceId),
                                    azureSearchResourceIdFormat,
                                    azureSearchResourceIdErrorMessage)
                            ]
                        }
                    ]
                }],
                readonlyControls: getReadonlyControl(azureSearchResourceIdFormat, azureSearchResourceIdErrorMessage)
            }
        }
    }
};
